import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ComboboxDirective } from './combobox.directive';
import { ComboboxDropdownComponent } from './combobox-dropdown.component';
import { ComboboxOptionDirective } from './combobox-option.directive';

@NgModule({
  declarations: [
    ComboboxDirective,
    ComboboxDropdownComponent,
    ComboboxOptionDirective
  ],
  imports: [
    CommonModule
  ],
  exports: [
    ComboboxDirective,
    ComboboxOptionDirective
  ]
})
export class ComboboxModule { }
